export const newsletterState = {
    "newsletters": {
        "newsletters": [
            {
                "groupingId": 1555421403998066,
                "name": "Newsletter Title",
                "archiveDates": [
                    "2019-05-07"
                ]
            }
        ]
    },
    "newslettersError": "",
    "archives": {
        "groupingId": 1555421403998066,
        "name": "Newsletter Title",
        "archiveDates": [
            "2019-05-02",
            "2019-05-03",
            "2019-05-07"
        ]
    },
    "archivesError": "",
    "currentData": {
        "data": {
            "tempPub": false,
            "tempGroupingId": null,
            "groupingId": 1555421403998066,
            "archiveGroupingId": null,
            "title": "Newsletter Title",
            "sectionList": [
                {
                    "id": 81,
                    "sectionOrder": 1,
                    "name": "You Cant Judge a Book By Its Cover",
                    "giList": [
                        82,
                        83,
                        84,
                        85,
                        86
                    ],
                    "subSections": null
                },
                {
                    "id": 87,
                    "sectionOrder": 2,
                    "name": "Everything But The Kitchen Sink",
                    "giList": [
                        88,
                        89
                    ],
                    "subSections": null
                },
                {
                    "id": 90,
                    "sectionOrder": 3,
                    "name": "Cut To The Chase",
                    "giList": [
                        91
                    ],
                    "subSections": null
                },
                {
                    "id": 92,
                    "sectionOrder": 4,
                    "name": "Right Out of the Gate",
                    "giList": [
                        93
                    ],
                    "subSections": null
                },
                {
                    "id": 94,
                    "sectionOrder": 5,
                    "name": "Keep Your Eyes Peeled",
                    "giList": [
                        95
                    ],
                    "subSections": null
                }
            ],
            "giData": {
                "82": {
                    "id": 82,
                    "itemId": null,
                    "secondItemId": null,
                    "description": "The world's most luxurious private jet? On board the groundbreaking Crystal Skye ",
                    "comment": "\"...Crystal chose not to install showers - as found on the Emirates and Etihad Airbus A380s - as it wouldn't be viable to store enough water for all 88 guests....\"",
                    "publishedDate": null,
                    "orderItem": 2,
                    "article": null,
                    "excerpt": "\"...Crystal chose not to install showers - as found on the Emirates and Etihad Airbus A380s - as it wouldn't be viable to store enough water for all 88 guests....\"",
                    "analysisId": 2614538804,
                    "articleGroupId": 2613316124,
                    "articleId": 2613316127,
                    "bestLicense": "lexisnexis",
                    "tone": 1,
                    "significance": 1,
                    "syndication": 3,
                    "copyrightNote": "The Telegraph (UK)",
                    "licenseCategory": 0,
                    "shareInfo": {
                        "facebookShares": 0,
                        "twitterShares": 0,
                        "pinterestShares": 0,
                        "totalImpressions": 65031280,
                        "totalShares": 0,
                        "followers": null,
                        "retweets": null
                    },
                    "formattedDate": "September 26, 2017",
                    "cityStateCountryString": "(Chantham)",
                    "hlTitle": null,
                    "hlBody": null,
                    "expired": false,
                    "title": "The world's most luxurious private jet? On board the groundbreaking Crystal Skye ",
                    "body": null,
                    "primaryAuthorByline": "Doug Gollan",
                    "secondaryAuthorByline": null,
                    "outletName": "The Telegraph (UK)",
                    "outletUrl": "http://www.telegraph.co.uk/",
                    "highlightedExcerpt": null,
                    "date": 1506428797118,
                    "outletPower": null,
                    "groupImpressions": 65031280,
                    "primaryImpressions": 57631280,
                    "titleRaw": "The world's most luxurious private jet? On board the groundbreaking Crystal Skye ",
                    "url": "http://www.telegraph.co.uk/luxury/travel/crystal-skye-private-jet-tour-air-cruises-charter-prices/"
                },
                "83": {
                    "id": 83,
                    "itemId": null,
                    "secondItemId": null,
                    "description": "In Trump Era, Boeing's Trade Dispute Boils Over Into a 'Multicountry Feud'",
                    "comment": "\"...It has sparred at the World Trade Organization for over a decade with European rival Airbus over allegations that its subsidies violate the group's rules....\"",
                    "publishedDate": null,
                    "orderItem": 4,
                    "article": null,
                    "excerpt": "\"...It has sparred at the World Trade Organization for over a decade with European rival Airbus over allegations that its subsidies violate the group's rules....\"",
                    "analysisId": 2614539830,
                    "articleGroupId": 2613010327,
                    "articleId": 2613010329,
                    "bestLicense": "lexisnexis",
                    "tone": -1,
                    "significance": 2,
                    "syndication": 1,
                    "copyrightNote": "New York Times",
                    "licenseCategory": 0,
                    "shareInfo": {
                        "facebookShares": 0,
                        "twitterShares": 0,
                        "pinterestShares": 0,
                        "totalImpressions": 76865318,
                        "totalShares": 0,
                        "followers": null,
                        "retweets": null
                    },
                    "formattedDate": "September 26, 2017",
                    "cityStateCountryString": "(New York, NY)",
                    "hlTitle": null,
                    "hlBody": null,
                    "expired": false,
                    "title": "In Trump Era, Boeing's Trade Dispute Boils Over Into a 'Multicountry Feud'",
                    "body": null,
                    "primaryAuthorByline": "Ana Swanson",
                    "secondaryAuthorByline": null,
                    "outletName": "New York Times",
                    "outletUrl": "http://www.nytimes.com/",
                    "highlightedExcerpt": null,
                    "date": 1506413096053,
                    "outletPower": null,
                    "groupImpressions": 76865318,
                    "primaryImpressions": 76865318,
                    "titleRaw": "In Trump Era, Boeing's Trade Dispute Boils Over Into a 'Multicountry Feud'",
                    "url": "https://www.nytimes.com/2017/09/25/business/boeing-commerce-department-bombardier-trump.html?mcubz=1"
                },
                "84": {
                    "id": 84,
                    "itemId": null,
                    "secondItemId": null,
                    "description": "@GLA_Airport Is Emirates going to start a Airbus A380 service to and from Glasgow to Dubai??",
                    "comment": "",
                    "publishedDate": null,
                    "orderItem": 5,
                    "article": null,
                    "excerpt": "",
                    "analysisId": 2614547298,
                    "articleGroupId": 2612126468,
                    "articleId": 2612126472,
                    "bestLicense": "gnip_twitter",
                    "tone": 0,
                    "significance": 0,
                    "syndication": 1,
                    "copyrightNote": "@Beckett10Scott",
                    "licenseCategory": 0,
                    "shareInfo": {
                        "facebookShares": 0,
                        "twitterShares": 0,
                        "pinterestShares": 0,
                        "totalImpressions": 39,
                        "totalShares": 0,
                        "followers": null,
                        "retweets": null
                    },
                    "formattedDate": "September 25, 2017",
                    "cityStateCountryString": "(Greenock)",
                    "hlTitle": null,
                    "hlBody": null,
                    "expired": false,
                    "title": "@GLA_Airport Is Emirates going to start a Airbus A380 service to and from Glasgow to Dubai??",
                    "body": null,
                    "primaryAuthorByline": "Scott Beckett",
                    "secondaryAuthorByline": null,
                    "outletName": "@Beckett10Scott",
                    "outletUrl": "http://www.twitter.com/Beckett10Scott",
                    "highlightedExcerpt": null,
                    "date": 1506361429160,
                    "outletPower": null,
                    "groupImpressions": 39,
                    "primaryImpressions": 39,
                    "titleRaw": "@GLA_Airport Is Emirates going to start a Airbus A380 service to and from Glasgow to Dubai??",
                    "url": "http://twitter.com/Beckett10Scott/statuses/912372035485126657"
                },
                "85": {
                    "id": 85,
                    "itemId": null,
                    "secondItemId": null,
                    "description": "Airbus inaugurates A330 completion center in China",
                    "comment": "\"...September 21, 2017 - Airbus has inaugurated its A330 Completion and Delivery Centre (C&DC) in Tianjin, China, in a move to expand its global footprint and strategic partnership with China....\"",
                    "publishedDate": null,
                    "orderItem": 6,
                    "article": null,
                    "excerpt": "\"...September 21, 2017 - Airbus has inaugurated its A330 Completion and Delivery Centre (C&DC) in Tianjin, China, in a move to expand its global footprint and strategic partnership with China....\"",
                    "analysisId": 2614545926,
                    "articleGroupId": 2608285062,
                    "articleId": 2608285064,
                    "bestLicense": "opoint",
                    "tone": 0,
                    "significance": 0,
                    "syndication": 2,
                    "copyrightNote": "Aircraft Interiors International",
                    "licenseCategory": 1,
                    "shareInfo": {
                        "facebookShares": 0,
                        "twitterShares": 0,
                        "pinterestShares": 0,
                        "totalImpressions": 6727,
                        "totalShares": 0,
                        "followers": null,
                        "retweets": null
                    },
                    "formattedDate": "September 25, 2017",
                    "cityStateCountryString": "",
                    "hlTitle": null,
                    "hlBody": null,
                    "expired": false,
                    "title": "Airbus inaugurates A330 completion center in China",
                    "body": null,
                    "primaryAuthorByline": "Staff Writer",
                    "secondaryAuthorByline": null,
                    "outletName": "Aircraft Interiors International",
                    "outletUrl": "http://www.aircraftinteriorsinternational.com",
                    "highlightedExcerpt": null,
                    "date": 1506355200000,
                    "outletPower": null,
                    "groupImpressions": 6727,
                    "primaryImpressions": 2650,
                    "titleRaw": "Airbus inaugurates A330 completion center in China",
                    "url": "http://www.aircraftinteriorsinternational.com/news.php?NewsID=87425"
                },
                "86": {
                    "id": 86,
                    "itemId": null,
                    "secondItemId": null,
                    "description": "JetBlue Revealed As Launch Customer For New A320 Cabin",
                    "comment": "\"...LONG BEACH, California-Airbus revealed JetBlue Airways as the launch...\"",
                    "publishedDate": null,
                    "orderItem": 7,
                    "article": null,
                    "excerpt": "\"...LONG BEACH, California-Airbus revealed JetBlue Airways as the launch...\"",
                    "analysisId": 2613895603,
                    "articleGroupId": 2613856338,
                    "articleId": 2613856340,
                    "bestLicense": "opoint",
                    "tone": 2,
                    "significance": 0,
                    "syndication": 1,
                    "copyrightNote": "Aviation Week",
                    "licenseCategory": 1,
                    "shareInfo": {
                        "facebookShares": 0,
                        "twitterShares": 0,
                        "pinterestShares": 0,
                        "totalImpressions": 407826,
                        "totalShares": 0,
                        "followers": null,
                        "retweets": null
                    },
                    "formattedDate": "September 24, 2017",
                    "cityStateCountryString": "(Washington, DC)",
                    "hlTitle": null,
                    "hlBody": null,
                    "expired": false,
                    "title": "JetBlue Revealed As Launch Customer For New A320 Cabin",
                    "body": null,
                    "primaryAuthorByline": "Kristin Majcher",
                    "secondaryAuthorByline": null,
                    "outletName": "Aviation Week",
                    "outletUrl": "http://www.aviationweek.com",
                    "highlightedExcerpt": null,
                    "date": 1506268800000,
                    "outletPower": null,
                    "groupImpressions": 407826,
                    "primaryImpressions": 407826,
                    "titleRaw": "JetBlue Revealed As Launch Customer For New A320 Cabin",
                    "url": "http://aviationweek.com/awincommercial/jetblue-revealed-launch-customer-new-a320-cabin"
                },
                "88": {
                    "id": 88,
                    "itemId": null,
                    "secondItemId": null,
                    "description": "The world's most luxurious private jet? On board the groundbreaking Crystal Skye ",
                    "comment": "\"...Crystal chose not to install showers - as found on the Emirates and Etihad Airbus A380s - as it wouldn't be viable to store enough water for all 88 guests....\"",
                    "publishedDate": null,
                    "orderItem": 1,
                    "article": null,
                    "excerpt": "\"...Crystal chose not to install showers - as found on the Emirates and Etihad Airbus A380s - as it wouldn't be viable to store enough water for all 88 guests....\"",
                    "analysisId": 2614538804,
                    "articleGroupId": 2613316124,
                    "articleId": 2613316127,
                    "bestLicense": "lexisnexis",
                    "tone": 1,
                    "significance": 1,
                    "syndication": 3,
                    "copyrightNote": "The Telegraph (UK)",
                    "licenseCategory": 0,
                    "shareInfo": {
                        "facebookShares": 0,
                        "twitterShares": 0,
                        "pinterestShares": 0,
                        "totalImpressions": 65031280,
                        "totalShares": 0,
                        "followers": null,
                        "retweets": null
                    },
                    "formattedDate": "September 26, 2017",
                    "cityStateCountryString": "(Chantham)",
                    "hlTitle": null,
                    "hlBody": null,
                    "expired": false,
                    "title": "The world's most luxurious private jet? On board the groundbreaking Crystal Skye ",
                    "body": null,
                    "primaryAuthorByline": "Doug Gollan",
                    "secondaryAuthorByline": null,
                    "outletName": "The Telegraph (UK)",
                    "outletUrl": "http://www.telegraph.co.uk/",
                    "highlightedExcerpt": null,
                    "date": 1506428797118,
                    "outletPower": null,
                    "groupImpressions": 65031280,
                    "primaryImpressions": 57631280,
                    "titleRaw": "The world's most luxurious private jet? On board the groundbreaking Crystal Skye ",
                    "url": "http://www.telegraph.co.uk/luxury/travel/crystal-skye-private-jet-tour-air-cruises-charter-prices/"
                },
                "89": {
                    "id": 89,
                    "itemId": null,
                    "secondItemId": null,
                    "description": "Boeing, EL AL Israel Airlines Celebrate Delivery of First 787 Dreamliner BA.N",
                    "comment": "",
                    "publishedDate": null,
                    "orderItem": 3,
                    "article": null,
                    "excerpt": "",
                    "analysisId": 2575648056,
                    "articleGroupId": 2575576115,
                    "articleId": 2575576117,
                    "bestLicense": "reuters",
                    "tone": 0,
                    "significance": 2,
                    "syndication": 1,
                    "copyrightNote": "Reuters",
                    "licenseCategory": 0,
                    "shareInfo": {
                        "facebookShares": 0,
                        "twitterShares": 0,
                        "pinterestShares": 0,
                        "totalImpressions": 41490906,
                        "totalShares": 0,
                        "followers": null,
                        "retweets": null
                    },
                    "formattedDate": "August 23, 2017",
                    "cityStateCountryString": "(New York, NY)",
                    "hlTitle": null,
                    "hlBody": null,
                    "expired": false,
                    "title": "Boeing, EL AL Israel Airlines Celebrate Delivery of First 787 Dreamliner BA.N",
                    "body": null,
                    "primaryAuthorByline": "Staff Writer",
                    "secondaryAuthorByline": null,
                    "outletName": "Reuters",
                    "outletUrl": "http://www.reuters.com/",
                    "highlightedExcerpt": null,
                    "date": 1503495006353,
                    "outletPower": null,
                    "groupImpressions": 41490906,
                    "primaryImpressions": 41490906,
                    "titleRaw": "Boeing, EL AL Israel Airlines Celebrate Delivery of First 787 Dreamliner BA.N",
                    "url": "http://pdf.reuters.com/htmlnews/htmlnews.asp?i=43059c3bf0e37541&u=urn:newsml:reuters.com:20170823:nPn4XTpfza"
                },
                "91": {
                    "id": 91,
                    "itemId": null,
                    "secondItemId": null,
                    "description": "Former Airbus UK chief tapped for senior role at Cobham-sources",
                    "comment": "",
                    "publishedDate": null,
                    "orderItem": 2,
                    "article": null,
                    "excerpt": "",
                    "analysisId": 2614540878,
                    "articleGroupId": 2607864625,
                    "articleId": 2607864627,
                    "bestLicense": "reuters",
                    "tone": 0,
                    "significance": 0,
                    "syndication": 1,
                    "copyrightNote": "Reuters",
                    "licenseCategory": 0,
                    "shareInfo": {
                        "facebookShares": 0,
                        "twitterShares": 0,
                        "pinterestShares": 0,
                        "totalImpressions": 41490906,
                        "totalShares": 0,
                        "followers": null,
                        "retweets": null
                    },
                    "formattedDate": "September 21, 2017",
                    "cityStateCountryString": "(New York, NY)",
                    "hlTitle": null,
                    "hlBody": null,
                    "expired": false,
                    "title": "Former Airbus UK chief tapped for senior role at Cobham-sources",
                    "body": null,
                    "primaryAuthorByline": "Tim Hepher",
                    "secondaryAuthorByline": null,
                    "outletName": "Reuters",
                    "outletUrl": "http://www.reuters.com/",
                    "highlightedExcerpt": null,
                    "date": 1506030302954,
                    "outletPower": null,
                    "groupImpressions": 41490906,
                    "primaryImpressions": 41490906,
                    "titleRaw": "Former Airbus UK chief tapped for senior role at Cobham-sources",
                    "url": "https://www.reuters.com/article/britain-cobham/former-airbus-uk-chief-tapped-for-senior-role-at-cobham-sources-idUSL5N1M25UJ"
                },
                "93": {
                    "id": 93,
                    "itemId": null,
                    "secondItemId": null,
                    "description": "In Trump Era, Boeing's Trade Dispute Boils Over Into a 'Multicountry Feud'",
                    "comment": "\"...It has sparred at the World Trade Organization for over a decade with European rival Airbus over allegations that its subsidies violate the group's rules....\"",
                    "publishedDate": null,
                    "orderItem": 9,
                    "article": null,
                    "excerpt": "\"...It has sparred at the World Trade Organization for over a decade with European rival Airbus over allegations that its subsidies violate the group's rules....\"",
                    "analysisId": 2614539830,
                    "articleGroupId": 2613010327,
                    "articleId": 2613010329,
                    "bestLicense": "lexisnexis",
                    "tone": -1,
                    "significance": 2,
                    "syndication": 1,
                    "copyrightNote": "New York Times",
                    "licenseCategory": 0,
                    "shareInfo": {
                        "facebookShares": 0,
                        "twitterShares": 0,
                        "pinterestShares": 0,
                        "totalImpressions": 76865318,
                        "totalShares": 0,
                        "followers": null,
                        "retweets": null
                    },
                    "formattedDate": "September 26, 2017",
                    "cityStateCountryString": "(New York, NY)",
                    "hlTitle": null,
                    "hlBody": null,
                    "expired": false,
                    "title": "In Trump Era, Boeing's Trade Dispute Boils Over Into a 'Multicountry Feud'",
                    "body": null,
                    "primaryAuthorByline": "Ana Swanson",
                    "secondaryAuthorByline": null,
                    "outletName": "New York Times",
                    "outletUrl": "http://www.nytimes.com/",
                    "highlightedExcerpt": null,
                    "date": 1506413096053,
                    "outletPower": null,
                    "groupImpressions": 76865318,
                    "primaryImpressions": 76865318,
                    "titleRaw": "In Trump Era, Boeing's Trade Dispute Boils Over Into a 'Multicountry Feud'",
                    "url": "https://www.nytimes.com/2017/09/25/business/boeing-commerce-department-bombardier-trump.html?mcubz=1"
                },
                "95": {
                    "id": 95,
                    "itemId": null,
                    "secondItemId": null,
                    "description": "The world's most luxurious private jet? On board the groundbreaking Crystal Skye ",
                    "comment": "\"...Crystal chose not to install showers - as found on the Emirates and Etihad Airbus A380s - as it wouldn't be viable to store enough water for all 88 guests....\"",
                    "publishedDate": null,
                    "orderItem": 8,
                    "article": null,
                    "excerpt": "\"...Crystal chose not to install showers - as found on the Emirates and Etihad Airbus A380s - as it wouldn't be viable to store enough water for all 88 guests....\"",
                    "analysisId": 2614538804,
                    "articleGroupId": 2613316124,
                    "articleId": 2613316127,
                    "bestLicense": "lexisnexis",
                    "tone": 1,
                    "significance": 1,
                    "syndication": 3,
                    "copyrightNote": "The Telegraph (UK)",
                    "licenseCategory": 0,
                    "shareInfo": {
                        "facebookShares": 0,
                        "twitterShares": 0,
                        "pinterestShares": 0,
                        "totalImpressions": 65031280,
                        "totalShares": 0,
                        "followers": null,
                        "retweets": null
                    },
                    "formattedDate": "September 26, 2017",
                    "cityStateCountryString": "(Chantham)",
                    "hlTitle": null,
                    "hlBody": null,
                    "expired": false,
                    "title": "The world's most luxurious private jet? On board the groundbreaking Crystal Skye ",
                    "body": null,
                    "primaryAuthorByline": "Doug Gollan",
                    "secondaryAuthorByline": null,
                    "outletName": "The Telegraph (UK)",
                    "outletUrl": "http://www.telegraph.co.uk/",
                    "highlightedExcerpt": null,
                    "date": 1506428797118,
                    "outletPower": null,
                    "groupImpressions": 65031280,
                    "primaryImpressions": 57631280,
                    "titleRaw": "The world's most luxurious private jet? On board the groundbreaking Crystal Skye ",
                    "url": "http://www.telegraph.co.uk/luxury/travel/crystal-skye-private-jet-tour-air-cruises-charter-prices/"
                }
            },
            "pubImages": [],
            "headerImage": null,
            "clientLogo": "https://s3.amazonaws.com/pr.dev.images2/PublicRelay-Dark-Logo-Horizontal-interlaced.png",
            "itemsForReport": null,
            "groupingTemplate": {
                "name": "Newsletter Title",
                "core": {
                    "includeDate": [
                        "true"
                    ],
                    "dateFormat": "Month D, YYYY",
                    "emailBackgroundHex": "#f2f2f2",
                    "contentBackgroundHex": "#ffffff",
                    "highlightKeywords": {
                        "include": "false"
                    },
                    "newsletterFont": "Arial,'Helvetica Neue',Helvetica,sans-serif"
                },
                "description": "",
                "header": {
                    "newsletterDate": {
                        "include": "true",
                        "hex": "#000000",
                        "format": "Month D, YYYY",
                        "fontSize": 18,
                        "styling": []
                    },
                    "interactiveVersion": {
                        "include": "button",
                        "button": {
                            "text": "Interactive Version",
                            "buttonHex": "#000000",
                            "fontHex": "#fafafa",
                            "fontSize": 18
                        }
                    },
                    "breakLine": {
                        "include": "true",
                        "hex": "#e6e6e6"
                    },
                    "image": {
                        "include": "false"
                    },
                    "displayName": {
                        "include": "true",
                        "text": "Daily News Report",
                        "hex": "#000000",
                        "fontSize": 32,
                        "styling": []
                    },
                    "legalStatement": {
                        "include": "false"
                    },
                    "customText": {
                        "include": "false"
                    },
                    "customImages": {
                        "include": "false"
                    }
                },
                "section": {
                    "style": {
                        "hex": "#000000",
                        "fontSize": 24,
                        "styling": [
                            "font-weight:bold",
                            "text-transform:uppercase"
                        ]
                    },
                    "topStories": {
                        "include": "false"
                    },
                    "toc": {
                        "include": "toc",
                        "label": "Table of Contents",
                        "includeFurtherReadingArticles": [],
                        "includeInteractiveVersionLink": []
                    },
                    "breakLines": {
                        "include": "true",
                        "hex": "#f2f2f2"
                    }
                },
                "article": {
                    "outletFormat": {
                        "hex": "#808080",
                        "fontSize": 14,
                        "styling": [
                            "font-weight:bold"
                        ]
                    },
                    "includeOutletCityState": "true",
                    "authorFormat": {
                        "hex": "#808080",
                        "fontSize": 14,
                        "styling": []
                    },
                    "dateFormat": {
                        "hex": "#808080",
                        "format": "Month D, YYYY",
                        "fontSize": 14,
                        "styling": []
                    },
                    "titleFormat": {
                        "hex": "#808080",
                        "fontSize": 14,
                        "styling": []
                    },
                    "textFormat": {
                        "hex": "#e65757",
                        "fontSize": 16,
                        "styling": []
                    },
                    "fullText": {
                        "include": "fullTextEmail",
                        "linkInteractiveVersion": []
                    },
                    "translateNeliContent": "true",
                    "links": {
                        "linkEntireArticle": "false",
                        "backToTopLinks": [
                            "true"
                        ],
                        "hex": "#18b4fe",
                        "fontSize": 14,
                        "styling": []
                    }
                },
                "misc": {
                    "dataLabelFormat": {
                        "hex": "#808080",
                        "fontSize": 14,
                        "styling": []
                    },
                    "metricFormat": {
                        "hex": "#000000",
                        "fontSize": 14,
                        "styling": []
                    },
                    "articleTone": {
                        "include": "icon"
                    },
                    "includeSignficance": "true",
                    "articleImpressions": {
                        "include": "primaryOutlet"
                    },
                    "includeSyndication": "true",
                    "articleShares": {
                        "include": "false"
                    },
                    "includeRetweets": "false",
                    "includeFollowers": "false",
                    "includeSharingIcons": "false",
                    "includeEmailIcon": "false",
                    "copyright": {
                        "hex": "#808080",
                        "fontSize": 14,
                        "styling": []
                    }
                }
            },
            "highlightingKeywords": [
                "Airbus",
                "Boeing",
                "A380",
                "Bloomberg",
                "airbus"
            ],
            "clientId": 2,
            "clientName": "airbus",
            "publishedDate": null,
            "vowUrl": null,
            "headerImageAlt": null,
            "appUrl": null,
            "cacheKey": null,
            "keyList": null,
            "formattedIndexDate": null,
            "formattedDate": "May 7, 2019",
            "webVersion": null,
            "emailContentMode": null,
            "legalStatement": "Legal Notice: This publication may only be distributed in accordance with applicable copyright laws. If you are unsure, please check with your Legal Department.",
            "interactiveUrl": null
        },
        "showMetrics": true,
        "showFullText": false
    },
    "currentDataError": "",
    "error": ""
};
